const STRINGS = {
  addFilesButtonLabel: "Add files",
  dropZoneInstructions: "or drag and drop files here to upload"
};
export default STRINGS;